import React, { Component } from "react";
import LoadingPanel from "../common/LoadingPanel";
import TovarFoto from "../common/TovarFoto";
import ZoznamVln from "./Vlny/ZoznamVln";
import ZoznamVlnaArtikle from "./Vlny/ZoznamVlnaArtikle";
import DialogWindow from "../common/DialogWindow";
import PdfViewer from "../common/PdfViewer";
import { sestavyController } from "../../controllers/sestavy.controller";
import { Button } from "@progress/kendo-react-buttons";
import { Localization } from "../common/Localization";
import confirmService from "../common/confirmService";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum } from "../../enums";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { tovarController } from "../../controllers/tovar.controller";

class VlnyDialogContent extends Component {
    state = {
        selectedVlnaIds: [],
        loading: true,
        selectedArtikelId: null,
        selectedVlnaId: null,
        errorMessage: null,
        pdfLoading: false,
        pdfPrint: true,
        pdfFile: null
    };

    componentDidMount() {
        tovarController.copyTableTovarFromSqlCloud().then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            }
            this.setState({
                loading: false
            });
        });
    }

    changeSelectedVlnaId = (selectedVlnaId) => {
        this.setState({
            selectedVlnaId: selectedVlnaId
        });
    };

    changeSelectedVlnaIds = (selectedVlnaIds) => {
        this.setState({
            selectedVlnaIds: selectedVlnaIds
        });
    };

    changeSelectedArtikelId = (selectedArtikelId) => {
        this.setState({
            selectedArtikelId: selectedArtikelId
        });
    };

    handleErrorMessage = (errorMessage) => {
        this.setState({
            errorMessage: errorMessage
        });
    };

    printVlnySestava = async (vlnaIds) => {
        const confirmResult = await confirmService.show({
            type: MessageTypeEnum.QUESTION,
            message: "Vytlačiť aj artikle s nulovým stavom ?",
            buttons: ButtonGroupEnum.YES_NO_CANCEL
        });

        if (confirmResult != ButtonMessageEnum.CANCEL) {
            this.setState({
                pdfLoading: true
            });

            var nuloveStavy = confirmResult == ButtonMessageEnum.YES;

            sestavyController.GetVlnyVratnehoTovaru(vlnaIds, nuloveStavy, (fileURL) => {
                this.setState({
                    pdfLoading: false,
                    pdfPrint: true,
                    pdfFile: fileURL
                });
            });
        }
    };

    handleVytlacitClick = async () => {
        var localizationService = provideLocalizationService(this);
        if (this.state.selectedVlnaIds.length === 0) {
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: localizationService.toLanguageString(
                    "VlnyFRM.Vyberte vlnu pre ktorú chcete tlačiť zostavu !",
                    "Vyberte vlnu pre ktorú chcete tlačiť zostavu !"
                )
            });
        } else {
            this.printVlnySestava(this.state.selectedVlnaIds);
        }
    };

    render() {
        let contents = this.state.loading ? (
            <LoadingPanel />
        ) : (
            <React.Fragment>
                <div id="VlnyDialogContent">
                    <div>
                        <div className="col-lg-5">
                            <ZoznamVln
                                changeSelectedVlnaId={this.changeSelectedVlnaId}
                                handleErrorMessage={this.handleErrorMessage}
                                multiselect={true}
                                changeSelectedVlnaIds={this.changeSelectedVlnaIds}
                            />
                        </div>

                        <div className="col-lg-4">
                            <ZoznamVlnaArtikle selectedVlnaId={this.state.selectedVlnaId} changeSelectedArtikelId={this.changeSelectedArtikelId} />
                        </div>

                        <div className="col-lg-3">
                            <TovarFoto idKarta={this.state.selectedArtikelId} />
                            <div className="vytlacit-btn-container">
                                <Button onClick={this.handleVytlacitClick} className="font-bold">
                                    <Localization messageKey={"VlnyFRM.Vytlačiť"} defaultMessage={"Vytlačiť"} />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <DialogWindow dialog={this.state.dialog} />
                <PdfViewer loading={this.state.pdfLoading} print={this.state.pdfPrint} pdfFile={this.state.pdfFile} />
            </React.Fragment>
        );
        contents = this.state.errorMessage == null ? contents : <div className="alert alert-danger">{this.state.errorMessage}</div>;
        return <div>{contents}</div>;
    }
}

export default VlnyDialogContent;



// WEBPACK FOOTER //
// ./src/components/dialogs/VlnyDialogContent.js